<template>
  <div class="container">

    <div class="row">
      <div class="col-md-12">
        <b-card title="Callback Filter" class="margin-bottom">

          <b-row class="my-1">
            <b-col md="4">
              <label for="callbackDate">Postcode</label>
            </b-col>
            <b-col md="4" v-if="postcodes">
              <b-input-group>
                <div class="multiselect-wrapper">
                  <multiselect
                    v-model="selectPostcodes"
                    placeholder="Search"
                    label="name"
                    track-by="id"
                    :options="postcodes"
                    :multiple="true"
                    :hide-selected="false"
                  >
                  <template #selection="{ values, isOpen }">
                    <span class="multiselect__single"
                          v-if="values.length > 1"
                          v-show="!isOpen">{{ values.length }} postcodes selected</span>
                  </template>
                </multiselect>            
                </div>
                  <b-dropdown
                    size="lg"
                    variant="outline"
                    toggle-class="text-decoration-none p-1"
                    menu-class="flag-menu"
                    right
                  >
                    <template #button-content>
                      <flag v-if="selectedCountryCode === 'gb'" iso="gb" />
                      <flag v-else-if="selectedCountryCode === 'ie'" iso="ie" />
                    </template>
                    <b-dropdown-item class="flag-item" @click="getPostcodes('gb')">
                      <flag iso="gb" />
                    </b-dropdown-item>
                    <b-dropdown-item class="flag-item" @click="getPostcodes('ie')">
                      <flag iso="ie" class="fs-1"/>
                    </b-dropdown-item>
                  </b-dropdown>                  
              </b-input-group>                            
            </b-col>
          </b-row>
          <b-row>
          </b-row>
          <b-row class="my-1">
            <b-col md="4">
              <label for="callbackDate">Sector</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="callbackDate"
                v-model="filter.sector"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="4">
              <label for="callbackDate">Callback From/To</label>
            </b-col>
            <b-col md="4">
              <b-form-datepicker
                id="callbackFrom"
                v-model="filter.callbackFrom"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="en-GB"
              ></b-form-datepicker>
            </b-col>
            <b-col md="4">
              <b-form-datepicker
                id="callbackTo"
                v-model="filter.callbackTo"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="en-GB"
              ></b-form-datepicker>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="4">
              <label for="callbackDate">Callback Time From/To</label>
            </b-col>
            <b-col md="4">
               <b-form-select
                id="callbackDate"
                v-model="filter.callbackTimeFrom"
                :options="callbackTime"
              ></b-form-select>
            </b-col>
            <b-col md="4">
              <b-form-select
                id="callbackDate"
                v-model="filter.callbackTimeTo"
                :options="callbackTime"
              ></b-form-select>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="4">
              <label for="priorityId">Priority</label>
            </b-col>
            <b-col md="4">
              <b-form-select
                id="priorityId"
                v-model="filter.priorityId"
                :options="priorities"
              ></b-form-select>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="4">
              <label for="search">Search</label>
            </b-col>
            <b-col md="8">
              <b-form-input
                id="search"
                v-model="filter.search"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="my-1">
          <b-col md="4">
          </b-col>
          <b-col md="8">
            <FeedbackButton title="Apply" icon="search" :busy="isBusy" :onClick="loadCallbacks" class="margin-right" :disabled="isBusy"/>
            <b-button type="button" variant="info" @click="clear">
              <font-awesome-icon icon="eraser" /> Clear
            </b-button>
            <b-alert v-if="error" class="my-1 me-5" show variant="danger" title="Error">{{error}}</b-alert>
          </b-col>
        </b-row>

        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">



        <b-card title="Callback List">

          <b-alert show variant="info" v-if="!callbackResults || callbackResults.length == 0"><strong>No Callbacks</strong> No callbacks are scheduled for you to call.</b-alert>

          <div v-if="callbackResults && callbackResults.length > 0">
            <b-table
              :items="callbackResults"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :busy.sync="isBusy"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:cell(company)="data">
                {{ data.item.companyName }}<br />
                <font-awesome-icon icon="envelope" /> {{ data.item.postcode
                }}<br />
                <div v-if="data.item.sector">
                  <font-awesome-icon icon="tag" /> {{ data.item.sector.name }}
                </div>
              </template>

              <template v-slot:cell(contact)="data">
                <div v-bind:class="{ red: data.item.companyVendors[0].preferredContactNumberCtps }"
                  v-if="
                    data.item.companyVendors &&
                    data.item.companyVendors.length > 0
                  "
                >
                  {{ data.item.companyVendors[0].fullname || `${data.item.companyVendors[0].firstName} ${data.item.companyVendors[0].lastName}`}}
                  <br />
                  <font-awesome-icon icon="phone" />
                  {{ data.item.companyVendors[0].preferredContactNumber }}
                </div>
              </template>

              <template v-slot:cell(callback)="data">
                <div
                  v-if="
                    data.item.callbackAttempts && data.item.callbackAttempts > 0
                  "
                >
                  {{ data.item.lastCallbackDatetime }}
                  <br />
                  {{ data.item.callbackAttempts }} attempts
                </div>
              </template>

              <template v-slot:cell(priority)="data">
                {{ getDate(data.item.callbackDatetime) }}
                <br />
                {{ data.item.callbackPriority.name }}
              </template>

              <template v-slot:cell(nav)="data">
                <div>
                  <b-button
                    variant="light"
                    size="sm"
                    class="nav-button"
                    type="button"
                    @click="addNote(data.item.id)"
                  >
                    <font-awesome-icon icon="plus" /> Add Note</b-button
                  >
                  <b-button
                    variant="warning"
                    size="sm"
                    class="nav-button"
                    type="button"
                    :to="'/company/' + data.item.id"
                  >
                    <font-awesome-icon icon="edit" /> Details</b-button
                  >
                </div>
                <div>
                  <b-button
                    variant="success"
                    size="sm"
                    class="nav-button"
                    type="button"
                    @click="call(data.item.id)"
                  >
                    <font-awesome-icon icon="phone" /> Call</b-button
                  >
                  <b-button
                    variant="danger"
                    size="sm"
                    class="nav-button"
                    type="button"
                    @click="release(data.item.id)"
                  >
                    <font-awesome-icon icon="times" /> Release</b-button
                  >
                </div>
                <div>
                  <b-button
                    variant="primary"
                    size="sm"
                    class="nav-button"
                    type="button"
                    @click="rearrange(data.item.id)"
                  >
                    <font-awesome-icon icon="repeat" /> Rearrange</b-button
                  >

                </div>
              </template>
            </b-table>
            <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-number
            last-number
            ></b-pagination>
          </div>
        </b-card>
      </div>
    </div>
    <CompanyNotesModal ref="companyNotesModal" :system-id="2" :companyId="selectedCompanyId"/>
    <RearrangeCallbacksModal ref="rearrangeCallbacksModal" :companyId="selectedCompanyId"/>
    <ReleaseCallbackModal ref="releaseCallbackModal" :companyId="selectedCompanyId" :onRelease="loadCallbacks"/>
  </div>
</template>

<script>
import { format, isAfter, parseISO } from "date-fns";
import CompanyNotesModal from '@/components/company/notes/CompanyNotesModal.vue';
import RearrangeCallbacksModal from '@/components/myCallbacks/RearrangeCallbacksModal.vue';
import ReleaseCallbackModal from '@/components/company/dispositions/ReleaseCallbackModal';
import CompanyService from '@/services/Company.service';
import LookupsService from '@/services/Lookups.service';
import Multiselect from "vue-multiselect";
import FeedbackButton from "@/components/shared/FeedbackButton.vue";

export default {
  components: { CompanyNotesModal, RearrangeCallbacksModal, Multiselect, ReleaseCallbackModal, FeedbackButton },
  created() {
    this.loadCallbacks();
    this.getPostcodes('gb');
  },
  data() {
    return {
      error: undefined,
      selectPostcodes: [],
      selectedCountryCode: '',
      postcodes: [],
      currentPage: 1,
      rows: 0,
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      perPage: 20,
      selectedCompanyId: null,
      callbackResults: [],
      currentCompanyId: null,
      filter: {
        postcode: null,
        sector: null,
        callbackFrom: null,
        callbackTo: null,
        callbackTimeFrom: null,
        callbackTimeTo: null,
        priorityId: null,
        search: null,
      },
      fields: [
        { key: "company", label: "Company Name", sortable: false },
        { key: "contact", label: "Primary Contact", sortable: false },
        { key: "callback", label: "Last Contacted", sortable: false },
        {
          key: "priority",
          label: "Callback Arranged/Priority",
          sortable: false,
        },
        { key: "nav", label: "", sortable: false },
      ],
      priorities: [
        { value: null, text: "Select Priority"},
        { value: "10", text: "Low" },
        { value: "20", text: "Medium" },
        { value: "30", text: "High" },
      ],
      callbackTime: [
        { value: null, text: "Select Time" },
        { value: "08:00", text: "8:00 AM" },
        { value: "08:15", text: "8:15 AM" },
        { value: "08:30", text: "8:30 AM" },
        { value: "08:45", text: "8:45 AM" },
        { value: "09:00", text: "9:00 AM" },
        { value: "09:15", text: "9:15 AM" },
        { value: "09:30", text: "9:30 AM" },
        { value: "09:45", text: "9:45 AM" },
        { value: "10:00", text: "10:00 AM" },
        { value: "10:15", text: "10:15 AM" },
        { value: "10:30", text: "10:30 AM" },
        { value: "10:45", text: "10:45 AM" },
        { value: "11:00", text: "11:00 AM" },
        { value: "11:15", text: "11:15 AM" },
        { value: "11:30", text: "11:30 AM" },
        { value: "11:45", text: "11:45 AM" },
        { value: "12:00", text: "12:00 PM" },
        { value: "12:15", text: "12:15 PM" },
        { value: "12:30", text: "12:30 PM" },
        { value: "12:45", text: "12:45 PM" },
        { value: "13:00", text: "1:00 PM" },
        { value: "13:15", text: "1:15 PM" },
        { value: "13:30", text: "1:30 PM" },
        { value: "13:45", text: "1:45 PM" },
        { value: "14:00", text: "2:00 PM" },
        { value: "14:15", text: "2:15 PM" },
        { value: "14:30", text: "2:30 PM" },
        { value: "14:45", text: "2:45 PM" },
        { value: "15:00", text: "3:00 PM" },
        { value: "15:15", text: "3:15 PM" },
        { value: "15:30", text: "3:30 PM" },
        { value: "15:45", text: "3:45 PM" },
        { value: "16:00", text: "4:00 PM" },
        { value: "16:15", text: "4:15 PM" },
        { value: "16:30", text: "4:30 PM" },
        { value: "16:45", text: "4:45 PM" },
        { value: "17:00", text: "5:00 PM" },
        { value: "17:15", text: "5:15 PM" },
        { value: "17:30", text: "5:30 PM" },
        { value: "17:45", text: "5:45 PM" },
        { value: "18:00", text: "6:00 PM" },
        { value: "18:15", text: "6:15 PM" },
        { value: "18:30", text: "6:30 PM" },
        { value: "18:45", text: "6:45 PM" },
        { value: "19:00", text: "7:00 PM" },
        { value: "19:15", text: "7:15 PM" },
        { value: "19:30", text: "7:30 PM" },
        { value: "19:45", text: "7:45 PM" },
        { value: "20:00", text: "8:00 PM" },
        { value: "20:15", text: "8:15 PM" },
        { value: "20:30", text: "8:30 PM" },
        { value: "20:45", text: "8:45 PM" },
        { value: "21:00", text: "9:00 PM" },
      ],
    };
  },
  methods: {
    openTransfer() {
      this.$refs.companyTransferRecieveModal.showModal();
    },
    async call(companyId) {
      this.selectedCompanyId = companyId;
      await this.$http.post("/company/lock/" + companyId);
      this.$router.push({ path: "company/" + companyId });
    },
    release(companyId) {
      this.selectedCompanyId = companyId;
      this.$refs.releaseCallbackModal.showModal();

    },
    getDate(date) {
      return format(new Date(date), "dd/MM/yyyy hh:mm");
    },

    loadCallbacks() {
      this.isBusy = true;
      if (this.selectPostcodes && this.selectPostcodes.length > 0) {
        console.log(this.selectPostcodes);
        this.filter.postcodeAreas = this.selectPostcodes.map(x => x.areaCode);
      }
      CompanyService.getFilteredCallbacks(this.filter).then((response) => {
        this.callbackResults = response.data;
        this.rows = response.data.length;
        this.isBusy = false;
      }).catch(() => {
        this.isBusy = false;
        this.clear();
        this.error = "Search Timeout!";
        setTimeout(() => {
          this.error = undefined;
        }, 5000);
      });
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (isAfter(new Date(), parseISO(item.callbackDatetime)))
        return "table-danger";
    },

    addNote(companyId) {
      this.selectedCompanyId = companyId;
      this.$refs.companyNotesModal.showModal();
    },

    rearrange(companyId) {
      this.selectedCompanyId = companyId;
      this.$refs.rearrangeCallbacksModal.showModal();
    },

    loadNotes() {
      return;
    },
    clear() {
      this.selectPostcodes = [];
      this.filter = {
        postcode: null,
        sector: null,
        callbackFrom: null,
        callbackTo: null,
        callbackTimeFrom: null,
        callbackTimeTo: null,
        priorityId: null,
        search: null,
      }
    },
    getPostcodes(countryCode){
      if (countryCode != this.selectedCountryCode){
        this.selectedCountryCode = countryCode;
        LookupsService.loadPostcodeArea(countryCode).then(result => {
          this.postcodes = result.data;
          this.selectPostcodes = [];
        })
      }
    }

  },
};
</script>

<style scoped>
  .nav-button {
    width:100px;
    margin-right:2px;
    margin-bottom: 4px;
    text-align: left;
  }

  .multiselect-wrapper .multiselect {
    width: 100% !important;   /* force it to fill the row */
  }
  .multiselect-wrapper .multiselect__tags {
    min-height: calc(2.25rem + 2px);
    display: flex;
    align-items: center;
  }
  .multiselect-wrapper {
    flex: 1 1 auto;
    min-width: 0;
  }
  .multiselect-wrapper .multiselect__tags {
    width: 100%;
    box-sizing: border-box;
  }
  .multiselect-wrapper .multiselect {
    width: 100%;
    max-width: 100%;
  }
</style>
